<style lang="less" scoped>
.tabs {
  .ImgArray {width: 1200px;padding: 0px;
    ul {list-style: none;margin: 0;padding: 0px;overflow: hidden;display: flex;justify-content: space-between;align-items: center;flex-wrap: wrap;
      li {width: 500px;height: 120px;display: flex;justify-content: space-between;align-items: center;margin: 10px 0px;
        img {width: 180px;height: 120px;background-color: #d1d1d1;box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3);border-radius: 4px; vertical-align: middle;cursor: pointer;}
        .titleBox {width: 300px;height: 100%;
          p {text-align: left;	font-family: AlibabaPuHuiTi-Regular;font-size: 12px;font-weight: normal;font-stretch: normal;line-height: 21px;letter-spacing: 1px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;}
          .tit {color: #08032b;cursor: pointer;}
          .type {color: #666666;cursor: pointer;}
          .time {color: #666666;cursor: pointer;}
        }
      }
    }
  }
}
</style>

<!-- 安进 2021.6.30 东盟矿业Tab列表组件 -->
<template>
  <div class="tabsList">
    <el-tabs class="tabs" v-model="activeName">
      <el-tab-pane v-for="(item, index) in this.tabsList" :key="index" :label="item.title" :name="item.id">
        <div class="ImgArray">
          <ul>
            <li v-for="(item, index) in item.listdata" :key="index">
              <img :src="item.thumb" @click="GoClick(item)"/>
              <div class="titleBox">
                <p class="tit">{{ item.title }}</p>
                <p class="type">类型：{{ item.type }}</p>
                <p class="time">时间：{{ item.time * 1000 | formatDate()  }}</p>
              </div>
            </li>
          </ul>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import filters from '../method/filter.js'
export default {
  props: ['tabsList'],
  mixins: [filters],
  data()
  {
    return {
      activeName: '1'
    }
  },
  methods: {
    GoClick(item)
    {
      this.$emit('GoClick', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/TabListDMKC.vue